/**
 * Labels, colours and icons for feedback categories, statuses and sources. One map used by
 * the tab chips, the table badges and the category select.
 */

/** Order = tab order. `chip` is the plural tab label, `badge` the colours from the design. */
export const CATEGORIES = [
  { key: 'price_issue', label: 'Price Issue', chip: 'Price Issues', badge: 'bg-amber-100 text-amber-900' },
  { key: 'receipt_scan', label: 'Receipt Scan', chip: 'Receipt Scan', badge: 'bg-blue-100 text-blue-900' },
  { key: 'ev_feature', label: 'EV Feature', chip: 'EV Feature', badge: 'bg-emerald-100 text-emerald-900' },
  { key: 'bug_report', label: 'Bug Report', chip: 'App Bugs', badge: 'bg-red-100 text-red-900' },
  { key: 'feature_request', label: 'Feature Request', chip: 'Feature Requests', badge: 'bg-sky-100 text-sky-900' },
  { key: 'app_review', label: 'App Review', chip: 'App Reviews', badge: 'bg-purple-100 text-purple-900' },
  { key: 'other', label: 'Other', chip: 'Other', badge: 'bg-surface-container text-on-surface-variant' },
];
export const CATEGORY_KEYS = CATEGORIES.map((c) => c.key);

/** Unknown categories from the backend still render, with the "Other" colours. */
export function categoryMeta(key) {
  return (
    CATEGORIES.find((c) => c.key === key) ?? {
      key,
      label: String(key ?? 'other').replace(/_/g, ' '),
      chip: key,
      badge: CATEGORIES[CATEGORIES.length - 1].badge,
    }
  );
}

/** Status tabs (with the design's coloured dots) and StatusBadge tones. "replied" is set by the server only. */
export const STATUSES = [
  { key: 'pending', label: 'Pending Reply', tone: 'pending', dot: 'bg-status-pending-dot' },
  { key: 'replied', label: 'Replied', tone: 'ok', dot: 'bg-status-ok-dot' },
  { key: 'closed', label: 'Closed', tone: 'neutral', dot: null },
];
export const STATUS_KEYS = STATUSES.map((s) => s.key);

export const statusMeta = (key) => STATUSES.find((s) => s.key === key) ?? { key, label: key ?? '—', tone: 'neutral', dot: null };

export const SOURCES = [
  { key: 'ios', label: 'iOS', icon: 'phone_iphone' },
  { key: 'android', label: 'Android', icon: 'phone_android' },
  { key: 'web', label: 'Web', icon: 'language' },
  { key: 'website', label: 'Website', icon: 'public' },
];
export const SOURCE_KEYS = SOURCES.map((s) => s.key);

export const sourceMeta = (key) => SOURCES.find((s) => s.key === key) ?? (key ? { key, label: key, icon: 'devices' } : null);

/** Date-range select. `custom` shows from/to inputs. */
export const DATE_RANGES = [
  { key: '7', label: 'Last 7 days' },
  { key: '30', label: 'Last 30 days' },
  { key: '90', label: 'Last 90 days' },
  { key: 'all', label: 'All time' },
  { key: 'custom', label: 'Custom range' },
];

export const LANGUAGES = { en: 'EN', du: 'NL', nl: 'NL' };
